import { DatabaseWrapper } from '../../../shared/databases/database.wrapper';
import { Database } from '../../../shared/databases/database';
import { DatabaseEnum } from 'src/app/shared/databases/databases.enum';
import { RepConnWrapper } from '../../repconn/repconn.wrapper';
import { ObjectWrapper } from 'src/app/shared/wrappers/object.wrapper';
import { Attribute } from 'src/app/shared/models/domain/attribute';
import { TargetWrapper } from '../../design/transforms/target/target.wrapper';

export class HiveWrapper extends DatabaseWrapper {

    constructor(database: Database) {
        super(database);

        this.dbTyp_Id = DatabaseEnum.hive.ID;
        this.name = DatabaseEnum.hive.NAME;
        this.code = DatabaseEnum.hive.CODE;
        this.equivalentTag = DatabaseEnum.hive.EQUIVALENT_TAG;
        this.showClevel = true;

        this.showRunTimePropertiesTab = true;
        this.hideSchemaNmColumn = false;

        this.showSettingsTab = true;
        this.showHdfsSettingsTab = true;
        this.showKerberosSettingsTab = true;
        this.showYARNSettingsTab = true;
        //this.showHBASESettingsTab = true;
        this.showZooKeeperSettingsTab = true;
        this.showStatisticsSettingsTab = true;
        this.showMapReduceSettingsTab = true;

        this.showUserPrincipal = true;
        //data object tabs
        this.showDataObjectPropertiesTab = true;
        this.showDDLOption = true;
        this.showViewDataTabOption = true;
        this.isShowObjProperties = true;
        this.isShowPIIColumn = true;
        this.showOverWritePartition = true;
        this.showDistAttributes = true;
        this.showDataDescription = false;
        //For Lookup
         this.showStaticObject = true;
        this.dataObjectConnDatabaseNm = 'Database';
        this.showTerminateEndDate = true;

        this.nativeDbTyp_Ids = [6, 14, 16, 32, 33];
        this.complexAttrDTyp_Ids = [11, 22, 33];
    }

    validateRepConn(repConnWrapper: RepConnWrapper): void {

        if (repConnWrapper.repConn.conn.host == "" &&
            repConnWrapper.repConn.conn.hiveServe2HACnf_Flg != 'Y') {
            repConnWrapper.inValid_Cds.push('NO_HOST');
        }

        if (repConnWrapper.repConn.conn.port == "" &&
            repConnWrapper.repConn.conn.hiveServe2HACnf_Flg != 'Y') {
            repConnWrapper.inValid_Cds.push('NO_PORT');
        }

        if (repConnWrapper.repConn.conn_Usr.conn_Usr == "" &&
            repConnWrapper.repConn.conn.secAuth != 'Kerberos' &&
            repConnWrapper.repConn.conn.secAuth != 'Kerberos & SSL') {
            repConnWrapper.inValid_Cds.push('NO_CONN_APPUSR');
        }

        if (repConnWrapper.repConn.conn_Usr.usrPasswd == "" &&
            repConnWrapper.repConn.conn.secAuth != 'Kerberos' &&
            repConnWrapper.repConn.conn.secAuth != 'Kerberos & SSL') {
            repConnWrapper.inValid_Cds.push('NO_PASSWORD');
        }

        if (repConnWrapper.repConn.conn.flagent_Id == -1) {
            repConnWrapper.inValid_Cds.push('ESM00202');
        }

        if (repConnWrapper.repConn.conn.zookeeper_Quorum_Host == "") {
            if (repConnWrapper.repConn.conn.hiveServe2HACnf_Flg == 'Y')
                repConnWrapper.inValid_Cds.push('NO_ZQH');
        }

        if (repConnWrapper.repConn.conn.secAuth == 'Kerberos' ||
            repConnWrapper.repConn.conn.secAuth == 'Kerberos & SSL') {
            if (!repConnWrapper.repConn.conn.hive_Principal.length) {
                repConnWrapper.inValid_Cds.push('HIVE_PRINCIPAL');
            }
            if (!repConnWrapper.repConn.conn.user_Principal.length) {
                repConnWrapper.inValid_Cds.push('USER_PRINCIPAL');
            }
            if (!repConnWrapper.repConn.conn.secKeyTab.length) {
                repConnWrapper.inValid_Cds.push('SECKEYTAB');
            }
        }
        if (repConnWrapper.repConn.conn.secAuth == 'SSL' ||
            repConnWrapper.repConn.conn.secAuth == 'Kerberos & SSL') {
            if (repConnWrapper.repConn.conn.ssl_trustStore == "") {
                repConnWrapper.inValid_Cds.push('NO_TRUST_STORE_PATH');
            }
        }
        if (repConnWrapper.repConn.conn_Dbs.length < 1) {
            repConnWrapper.inValid_Cds.push('NO_DATABASE');
        }
    }

    getDerivedAttributeColumns(objectWrapper: ObjectWrapper, component: any, isMax: boolean = false, attributes: Array<Attribute> = new Array<Attribute>(), isHiveNative: boolean = false,hideOrderBy): Array<any> {
        return [
            this.attributeTabulator.getCheckBoxColumn(objectWrapper),
            this.attributeTabulator.getSrt_Order(),
            this.attributeTabulator.getAttr_Id(),
            this.attributeTabulator.getAttrNm(objectWrapper,component),
            this.attributeTabulator.getAttrDTyp_Id(objectWrapper),
            this.attributeTabulator.getAttrPrec(objectWrapper),
            this.attributeTabulator.getAttrScale(objectWrapper),
            this.attributeTabulator.getMaxFlag(objectWrapper, isMax),
            this.attributeTabulator.getDistKeyFlag(objectWrapper),
            this.attributeTabulator.getOrderBy(objectWrapper, component,hideOrderBy),
            this.attributeTabulator.getPartitionflag(objectWrapper, isHiveNative),
            this.attributeTabulator.getAttrExprVal(objectWrapper, component),
            this.attributeTabulator.getValid_Cd(objectWrapper, component),
        ]
    }

    getAttributeColumns(objectWrapper: ObjectWrapper,
        attributes: Array<Attribute> = new Array<Attribute>(), component: any = null,hideRowSelection:boolean=true): Array<any> {
        return [
            this.attributeTabulator.getCheckBoxColumn(objectWrapper,hideRowSelection),
            this.attributeTabulator.getSrt_Order(),
            this.attributeTabulator.getAttr_Id(),
            this.attributeTabulator.getAttrNm(objectWrapper,component),
            this.attributeTabulator.getAttrDTyp_Id(objectWrapper, attributes, component),
            this.attributeTabulator.getAttrPrec(objectWrapper),
            this.attributeTabulator.getAttrScale(objectWrapper),
            this.attributeTabulator.getAttrPiiIdentifierFlag(objectWrapper, true),//
            this.attributeTabulator.getNotNullFlag(objectWrapper),
            this.attributeTabulator.getAttrKeyTyp_Id(objectWrapper),
            this.attributeTabulator.getOrderBy(objectWrapper, component),
            this.attributeTabulator.getPartitionflag(objectWrapper),
            this.attributeTabulator.getClusterFlag(objectWrapper),
            this.attributeTabulator.getDescription(objectWrapper),
        ]
    }

    getSourceAttributeColumns(objectWrapper: ObjectWrapper, isComplex: boolean = false,
        isShowPIIColumn: boolean = false, isGoogleAnalytics: boolean = false,
        isEncryptedFlag: boolean = false, isMax: boolean = false, component: any): Array<any> {
        return [
            this.attributeTabulator.getCheckBoxColumn(objectWrapper),
            this.attributeTabulator.getSrt_Order(),
            this.attributeTabulator.getAttr_Id(),
            this.attributeTabulator.getClevel(objectWrapper, isComplex),
            this.attributeTabulator.getAttrNm(objectWrapper,component),
            this.attributeTabulator.getAttrDTyp_Id(objectWrapper),
            this.attributeTabulator.getExplodeFlag(objectWrapper, isComplex),
            this.attributeTabulator.getAttrPrec(objectWrapper),
            this.attributeTabulator.getAttrScale(objectWrapper),
            this.attributeTabulator.getAttrPiiIdentifierFlag(objectWrapper, isShowPIIColumn),
            this.attributeTabulator.getEncryptedFlag(objectWrapper, isEncryptedFlag),
            // this.attributeTabulator.getDistKeyFlag(objectWrapper),
            this.attributeTabulator.getPartitionflag(objectWrapper),
            // this.attributeTabulator.getOrgKeyFlag(objectWrapper),
            this.attributeTabulator.getOrderBy(objectWrapper, component),
            this.attributeTabulator.getLnk_Attr_Id(objectWrapper),
            this.attributeTabulator.getLnk_Attr_Datatype(objectWrapper),
            this.attributeTabulator.getValid_Cd(objectWrapper, component),
        ]
    }

    // getRollupSelectAttributeColumns(objectWrapper: ObjectWrapper,component:any): Array<any> {
    //     return [
    //         this.attributeTabulator.getCheckBoxColumn(objectWrapper),
    //         this.lAttributeTabulator.getSrt_Order(),
    //         this.lAttributeTabulator.getLAttr_Id(),
    //         this.lAttributeTabulator.getLAttrNm(objectWrapper),
    //         this.lAttributeTabulator.getSelectColumn(objectWrapper),
    //         this.lAttributeTabulator.getAttrDTypNm(objectWrapper),
    //         this.lAttributeTabulator.getLAttrPrec(objectWrapper),
    //         this.lAttributeTabulator.getLAttrScale(objectWrapper),
    //        // this.lAttributeTabulator.getLAttrType(objectWrapper),
    //         //this.lAttributeTabulator.getLAttrFunction(objectWrapper),
    //         this.lAttributeTabulator.getDistKeyFlag(objectWrapper,component),
    //         //this.lAttributeTabulator.getOrgKeyFlag(objectWrapper),
    //         this.lAttributeTabulator.getPartFlag(objectWrapper,component),
    //         this.lAttributeTabulator.getOrderBy(objectWrapper,component)
    //     ]
    // }


    getLAttributeColumns(objectWrapper: ObjectWrapper, component): Array<any> {
        return [
            this.attributeTabulator.getCheckBoxColumn(objectWrapper),
            this.lAttributeTabulator.getSrt_Order(),
            this.lAttributeTabulator.getLAttr_Id(),
            this.lAttributeTabulator.getLAttrNm(objectWrapper),
            this.lAttributeTabulator.getSelectColumn(objectWrapper),
            this.lAttributeTabulator.getAttrDTypNm(objectWrapper),
            this.lAttributeTabulator.getLAttrPrec(objectWrapper),
            this.lAttributeTabulator.getLAttrScale(objectWrapper),
            this.lAttributeTabulator.getLAttrType(objectWrapper),
			this.lAttributeTabulator.getLAttrFunction(objectWrapper),
            this.lAttributeTabulator.getDistKeyFlag(objectWrapper, component),
            this.lAttributeTabulator.getPartFlag(objectWrapper, component),
            this.lAttributeTabulator.getOrderBy(objectWrapper, component),
        ]
    }

    getTgt_Attr_LnkColumns(dbTyp_Id: number, tgtLoadType: string, targetWrapper: TargetWrapper): Array<any> {
        let columns: Array<any> = new Array<any>();

        columns.push(this.tgt_Attr_LnkTabulator.getTgt_dObj_Inst_Attr_Id(targetWrapper));
        columns.push(this.tgt_Attr_LnkTabulator.getTgtDTypNm(targetWrapper));
        columns.push(this.tgt_Attr_LnkTabulator.getSrcAttrNm(targetWrapper));
        columns.push(this.tgt_Attr_LnkTabulator.getSrcDTypNm(targetWrapper));
        columns.push(this.tgt_Attr_LnkTabulator.getOrderBy(targetWrapper));

        if (tgtLoadType != 'INS') {
            columns.push(this.tgt_Attr_LnkTabulator.getUpdKeyFlag(targetWrapper));
        }

        if (tgtLoadType == 'SCD') {
            columns.push(this.tgt_Attr_LnkTabulator.getScdFlag(targetWrapper));
            columns.push(this.tgt_Attr_LnkTabulator.getHashKey(targetWrapper));
            columns.push(this.tgt_Attr_LnkTabulator.getScdStartDtFlag(targetWrapper));
            columns.push(this.tgt_Attr_LnkTabulator.getScdEndDtFlag(targetWrapper));
            columns.push(this.tgt_Attr_LnkTabulator.getCurrIndFlag(targetWrapper));
            columns.push(this.tgt_Attr_LnkTabulator.getSurrogate_Key(targetWrapper));
        }

        columns.push(this.tgt_Attr_LnkTabulator.getValid_Cd(targetWrapper));

        return columns;
    }

    // showAttributeNotNull(attribute: Attribute, objectWrapper: ObjectWrapper): boolean {
    // 	if (attribute.attrDTyp_Id !=(this.database.arrayId||this.database.mapId||this.database.) return true;

    // 	return false

    //     }

    getConn_DbColumns(repConnWrapper: RepConnWrapper, component: any): Array<any> {
        return [
            this.conn_DbsTabultor.getCheckBoxColumn(repConnWrapper),
            this.conn_DbsTabultor.getSrt_Order(),
            this.conn_DbsTabultor.getName(repConnWrapper),
            this.conn_DbsTabultor.getDatabaseNm(repConnWrapper, component),
            this.conn_DbsTabultor.getStgDb_Flag(repConnWrapper)
        ]
    }

    hideNotNullFlag(attribute): boolean {

        return this.complexAttrDTyp_Ids.indexOf(parseInt(attribute.attrDTyp_Id)) != -1;
    }

    hideAttrKeyTyp_Id(attribute): boolean {

        return this.complexAttrDTyp_Ids.indexOf(parseInt(attribute.attrDTyp_Id)) != -1;
    }
}
